<template>
  <section>
    <!-- RIGHT -->
    <div class="col-span-6 px-4 sm:px-0">
      <!-- TABS -->
      <div
        class="inline-flex w-full sm:w-auto rounded-md border border-gray-200 shadow-sm overflow-hidden bg-bgInactive"
      >
        <button
          @click="activeTab = 'regular'"
          :class="tabClass('regular')"
          class="flex-1 text-center text-sm sm:text-base py-2 sm:py-3 px-2 sm:px-4"
        >
          Regular
        </button>

        <button
          @click="activeTab = 'special'"
          :class="tabClass('special')"
          class="flex-1 text-center text-sm sm:text-base py-2 sm:py-3 px-2 sm:px-4"
        >
          Special
        </button>
      </div>

      <!-- CONTENT -->
      <div class="py-4 sm:py-7">
        <!-- REGULAR HOLIDAYS -->
        <ul v-if="activeTab === 'regular'" class="space-y-4 sm:space-y-6">
          <div v-if="!renderLoading">
            <div class="py-2 sm:py-4">
              <h1 class="text-xl sm:text-2xl font-bold text-primarydark">Regular Holidays</h1>
            </div>

            <ul>
              <li v-for="(item, index) in itemRegularHoliday" :key="index" class="my-2 sm:my-3">
                <div
                  class="min-h-20 sm:min-h-24 bg-stone-50 rounded-md shadow-sm flex items-center px-4 sm:px-8 py-2 sm:py-3 gap-2 sm:gap-4"
                >
                  <div class="flex flex-col justify-center items-start">
                    <h1 class="text-xl sm:text-3xl font-bold">
                      {{ renderDayFormat(item.dbDate) }}
                    </h1>
                    <h1 class="text-sm sm:text-lg font-medium text-primarylightdark">
                      {{ renderMonthFormat(item.dbDate).toUpperCase() }}
                    </h1>
                  </div>
                  <div class="ml-4 text-left">
                    <h1 class="text-base sm:text-2xl font-bold text-primaryPalette">
                      {{ item.description }}
                    </h1>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="flex justify-center items-center py-4">
            <LoadingGlobal />
          </div>
        </ul>

        <!-- SPECIAL HOLIDAYS -->
        <ul v-else class="space-y-4 sm:space-y-6">
          <div v-if="!renderLoading">
            <div class="py-2 sm:py-4">
              <h1 class="text-xl sm:text-2xl font-bold text-primarydark">
                Special Non-Working Holidays
              </h1>
            </div>

            <ul>
              <li v-for="(item, index) in itemSpecialHoliday" :key="index" class="my-2 sm:my-3">
                <div
                  class="min-h-20 sm:min-h-24 bg-stone-50 rounded-md shadow-sm flex items-center px-4 sm:px-8 py-2 sm:py-3 gap-2 sm:gap-5"
                >
                  <div class="flex flex-col justify-center items-start">
                    <h1 class="text-xl sm:text-3xl font-bold">
                      {{ renderDayFormat(item.dbDate) }}
                    </h1>
                    <h1 class="text-sm sm:text-lg font-medium text-primarylightdark">
                      {{ renderMonthFormat(item.dbDate).toUpperCase() }}
                    </h1>
                  </div>
                  <div class="ml-4 text-left">
                    <h1 class="text-base sm:text-2xl font-bold text-primaryPalette">
                      {{ item.description }}
                    </h1>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="flex justify-center items-center py-4" v-else>
            <LoadingGlobal />
          </div>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import { ref, onMounted, inject, watch } from 'vue';
import reusableBase from '@/utils/reusables/dateFormat';
export default {
  components: {},
  setup() {
    const { renderDayFormat, renderMonthFormat } = reusableBase();
    const axios = inject('$axios');
    const activeTab = ref('regular');
    const tabClass = (tab) => {
      const isActive = activeTab.value === tab;
      return [
        'transition-all duration-200',
        isActive
          ? 'bg-[#FFF7E6] text-orange-500'
          : 'bg-bgInactive text-primaryInactiveLight hover:text-gray-600'
      ].join(' ');
    };
    const itemRegularHoliday = ref([]);
    const itemSpecialHoliday = ref([]);
    const renderLoading = ref(true);

    const renderHoliday = async () => {
      try {
        renderLoading.value = true;
        const [regularRes, specialRes] = await Promise.all([
          axios.get('https://urchin-app-t57nb.ondigitalocean.app/api/gazette/getHoliday', {
            params: { types: 'Regular', year: 2026 }
          }),
          axios.get('https://urchin-app-t57nb.ondigitalocean.app/api/gazette/getHoliday', {
            params: { types: 'Special', year: 2026 }
          })
        ]);
        itemRegularHoliday.value = regularRes.data || [];
        itemSpecialHoliday.value = specialRes.data || [];
      } catch (error) {
        console.log('render', error.response || error);
      } finally {
        renderLoading.value = false;
      }
    };

    onMounted(() => renderHoliday());

    watch(activeTab, () => {
      renderLoading.value = true;
      renderHoliday();
    });

    return {
      activeTab,
      tabClass,
      itemRegularHoliday,
      itemSpecialHoliday,
      renderDayFormat,
      renderMonthFormat,
      renderLoading
    };
  }
};
</script>
